import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f0c6eb04"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "edit-image-modal border-white" }
const _hoisted_2 = { class: "modal-header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Edit image", -1))
const _hoisted_4 = { class: "row modal-body" }
const _hoisted_5 = { class: "cropper-toolbar mb-2" }
const _hoisted_6 = { class: "modal-footer" }
const _hoisted_7 = { class: "col-lg-12 p-0" }
const _hoisted_8 = { class: "action-wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_fa = _resolveComponent("fa")!
  const _component_vue_cropper = _resolveComponent("vue-cropper")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, {
    modelValue: _ctx.isShow,
    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.isShow) = $event)),
    close: _ctx.closeModal
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("button", {
            class: "close",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
          }, "x")
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("button", {
              class: "gray-btn",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.zoomIn && _ctx.zoomIn(...args)))
            }, [
              _createVNode(_component_fa, { icon: "search-plus" })
            ]),
            _createElementVNode("button", {
              class: "gray-btn search",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.zoomOut && _ctx.zoomOut(...args)))
            }, [
              _createVNode(_component_fa, { icon: "search-minus" })
            ]),
            _createElementVNode("button", {
              class: "gray-btn",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.rotateLeft && _ctx.rotateLeft(...args)))
            }, [
              _createVNode(_component_fa, { icon: "rotate-left" })
            ]),
            _createElementVNode("button", {
              class: "gray-btn",
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.rotateRight && _ctx.rotateRight(...args)))
            }, [
              _createVNode(_component_fa, { icon: "rotate-right" })
            ])
          ]),
          _createVNode(_component_vue_cropper, {
            ref: "cropper",
            class: "cropper-img",
            alt: "Source Image",
            "drag-mode": "crop",
            background: true,
            cropmove: _ctx.cropImage,
            "img-style": { height: '460px', width: '766px' },
            "min-container-height": 380,
            "min-container-width": 650,
            src: _ctx.imgSrc,
            "view-mode": 2
          }, null, 8, ["cropmove", "src"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("button", {
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args))),
                class: "btn cancel-btn mr-3"
              }, "Cancel"),
              _createElementVNode("button", {
                type: "submit",
                class: "btn btn-secondary",
                onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.submitImage && _ctx.submitImage(...args)))
              }, "Save")
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "close"]))
}